import { useLanguageContext } from "@/contexts/language";
import { LanguageMap } from "@potoo-modules/constants";
import { CodiMeFooter, CodiMeFooterEn } from "@ui-components/components/CodiMeFooter";

const Footer = () => {
  const { language } = useLanguageContext();

  if (language === LanguageMap.ENGLISH) return <CodiMeFooterEn />;
  else return <CodiMeFooter />;
};

export default Footer;
